import { type CarProps } from '@/components/atoms/Car'
import { type TransportRequestStatus } from '@/components/molecules/Status'
import { type TeamStatus } from '@/model/firestore/schema/TeamStatusZod'
import { type TeamMessage } from '@/state/teamMessages/types'
import { type Team } from '@/state/teams/types'

export const teamStatus = (team: Team): CarProps['state'] => buildTeamStatus(team.status, team.transportRequest?.status)

export const messageTeamStatus = (message: TeamMessage): CarProps['state'] =>
  buildTeamStatus(message.teamStatus, message.transportRequestStatus)

export const channelMessageTeamStatus = (status?: TeamStatus): CarProps['state'] => buildTeamStatus(status)

const buildTeamStatus = (
  status?: TeamStatus,
  transportRequestStatus?: TransportRequestStatus | 'on_board'
): CarProps['state'] => {
  switch (transportRequestStatus) {
    case 'allocated':
      return 'allocated'
    case 'assigned':
      return 'assigned'
    case 'onboarded':
    case 'on_board':
      return 'onboarded'
    default:
      switch (status) {
        case 'AVAILABLE_IN_LOCATION':
        case 'AVAILABLE_IN_INSTITUTION':
        case 'AVAILABLE_IN_REGION':
        case 'AVAILABLE_AT_COORDINATES':
          return 'available'
        case 'ON_BREAK':
          return 'onHold'
        case 'IN_RETURN':
          return 'inReturn'
        default:
          return 'pending'
      }
  }
}
